import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess as seoSegmentationSearchResultsSuccessType } from '@/__generated__/seoSegmentationListingPage';
import { SEARCH_DIRECTORY_TEMPLATE_TYPE } from '@/constants';

/**
 * Determines the search directory template type based on the search results.
 *
 * @param searchResults - The search results object containing arrays of different result types
 * @returns The appropriate search directory template type based on the composition of search results,
 *          or null if no matching pattern is found
 *
 * The function evaluates the following scenarios:
 * - Hybrid: Both caregiver and provider results exist
 * - Caregiver: Only caregiver results exist
 * - SMB: Only provider results exist
 * - Job: Job or archived job results exist
 */
export const searchDirectoryTypeFromSearchResults = (
  searchResults: NonNullable<seoSegmentationSearchResultsSuccessType>
) => {
  const {
    caregiverSearchResults,
    jobSearchResults,
    providerSearchResults,
    archivedJobSearchResults,
  } = searchResults;

  // Hybrid results
  if (caregiverSearchResults.length > 0 && providerSearchResults.length > 0) {
    return SEARCH_DIRECTORY_TEMPLATE_TYPE.HYBRID;
  }

  // Caregiver results
  if (caregiverSearchResults.length > 0 && providerSearchResults.length === 0) {
    return SEARCH_DIRECTORY_TEMPLATE_TYPE.CAREGIVER;
  }

  // SMB Results
  if (providerSearchResults.length > 0 && caregiverSearchResults.length === 0) {
    return SEARCH_DIRECTORY_TEMPLATE_TYPE.SMB;
  }

  // Job and Archived Job Results
  if (jobSearchResults.length > 0 || archivedJobSearchResults.length > 0) {
    return SEARCH_DIRECTORY_TEMPLATE_TYPE.JOB;
  }

  return null; // Fallback to null if no results found
};
